import { Typography, styled } from "@material-ui/core";

export const DescriptionText = styled(Typography)({
  color: "#707087",
  fontFamily: "'Inter', 'sans-serif'",
  fontSize: "12px",
  fontWeight: 400,
  // Dark mode (additive): only applies under the `.dark` root; light unchanged.
  ".dark &": {
    color: "hsl(var(--sds-muted-foreground))",
  },
});
